import cn from 'classnames';

export const SalesforceSettingContainer = ({ children }) => {
	return (
		<div className={cn('salesforce-container', 'container-fluid', 'rounded', 'bg-white', 'mt-4', 'p-0')}>
			<div className={cn('border-bottom')}>
				<div className={cn('p-4', 'pb-2', 'text-muted')}>
					<p className={cn('header-text')}>Field Mapping</p>
					<p className={cn('subheader-text')}>
						Field Mapping Allows you to enrich your Salesforce CRM with data from BenefitFlow
					</p>
				</div>
			</div>
			<div className={cn('p-4')}>{children}</div>
		</div>
	);
};
